import React from "react"
export function Settings(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M11.214 1.505v1.85c.959.18 1.846.563 2.615 1.103l1.323-1.322 1.717 1.717-1.333 1.334A6.704 6.704 0 0116.6 8.79H18.5v2.43h-1.909a6.705 6.705 0 01-1.074 2.584l1.352 1.353-1.717 1.717-1.35-1.35c-.763.53-1.64.906-2.587 1.084v1.897h-2.43v-1.883a6.704 6.704 0 01-2.617-1.066l-1.32 1.318-1.717-1.717 1.308-1.308a6.706 6.706 0 01-1.106-2.63H1.5V8.791l1.825-.001a6.705 6.705 0 011.094-2.647l-1.288-1.29 1.717-1.717 1.292 1.29a6.705 6.705 0 012.645-1.084V1.505h2.43zM9.962 5.239a4.742 4.742 0 100 9.485 4.742 4.742 0 000-9.485z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__settings"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
